import React from 'react';
import { useTranslation } from 'react-i18next';

import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { withStyles } from '@material-ui/core/styles';
import CardMedia from '@material-ui/core/CardMedia';

const styles = () => ({
  card: {
    backgroundColor: 'transparent',
    boxShadow: '0 0 0 0',
  },
  cardLogo: {
    width: '50px',
    height: '50px',
    marginBottom: '10px',
  },
});

type Props = {
  classes: Object,
  img: Object,
  title: String,
  content: String,
};

function ValueCard({ img, title, content, classes }: Props) {
  const { t } = useTranslation();
  return (
    <Card itemScope className={classes.card}>
      <CardContent align="center">
        <meta itemProp="image" content={img} />
        <CardMedia className={classes.cardLogo} image={img} title={title} />

        <Typography variant="h5" component="h4" gutterBottom itemProp="name">
          {t(title)}
        </Typography>
        <Typography color="textSecondary" itemProp="description">
          {t(content)}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default withStyles(styles)(ValueCard);
